import anime from "animejs";
import S, { DataSignal } from "s-js";
import * as Surplus from "surplus";
import { JSXChildren } from "./layout";

export function Collapse(props: { isOpen: DataSignal<boolean> } & JSXChildren) {
    let ref: HTMLDivElement | undefined;
    let isOpen: boolean;

    S.on(props.isOpen, () => {
        window.requestAnimationFrame(() => {
            if (!ref) return;
            const isInitialRender = isOpen === undefined;
            if (props.isOpen()) {
                if (isOpen) return;

                isOpen = true;

                ref.style.height = "auto";
                const height = ref.clientHeight;

                anime.set(ref, { height: 0, opacity: 0 });
                anime({
                    targets: ref,
                    height,
                    easing: "easeOutQuad",
                    duration: isInitialRender ? 0 : height < 80 ? 75 : 400,
                    opacity: 1,
                }).finished.then(() => {
                    if (!ref) return;
                    ref.style.height = "auto";
                });
            } else {
                if (isOpen !== undefined && !isOpen) return;

                isOpen = false;

                const height = ref.clientHeight;
                ref.style.height = height + "px";
                anime({
                    targets: ref,
                    height: 0,
                    easing: "easeInOutSine",
                    duration: isInitialRender ? 0 : height < 80 ? 150 : 550,
                    opacity: 0,
                });
            }
        });
    });

    return (
        <div ref={ref} style={{ overflow: "hidden" }}>
            {props.children as JSX.Children}
        </div>
    );
}
